<template>
<div class="popup" v-cloak v-if="deleteTaskShow">
    <div class="content" id="deleteTask">
        <div class="title">
              {{$t('language.popup.taskListPopup.deleteTask')}}
            <div class="icon white-close dialog-close" @click="deleteTaskShow=false"></div>
        </div>
        <div class="delete-body">
            <div class="delete-info">
                <div>{{$t('language.popup.taskListPopup.deleteSingleTask')}}</div>
                <div v-if="false">{{$t('language.popup.taskListPopup.sureDeleteTask')}}</div>
            </div>
            <div class="delete-task-button">
                <button @click="deleteTask()">{{$t('language.common.delete')}}</button>
            </div>
        </div>

    </div>

</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import taskListUtils from "@/js/workspace/task_list_util.js";
export default {
    data() {
        return {
            deleteTaskShow: false,
            deleteItem: '',
            itemIndex: '',

        }
    },
    methods: {
        deleteTask() {//发送删除单个任务请求
            let taskType;
            let deleteData = this.getDeleteData();
            let that=this;
            if(this.deleteItem.branchType!='realtime'){
                if(this.deleteItem.branchType =='businessTransfer'){
                   this.deleteBusinessTransfer();
                   return;
                }
            this.Utils.doTasksRequest("delete", deleteData).then(res => {
                if (res.status == 200) {
                 that.deleteTaskRespone(deleteData);
                }else{
                        that.$toast({
                            text: that.$t('language.exception.'+ res.reason),
                            type: 'fail',
                            idValue: "rightBodyList"
                        });
                }
            }, err => {
                    that.$toast({
                        text: err,
                        type: 'fail',
                        idValue: "rightBodyList"
                    });
                });
        }else{
            //删除即时同步任务
             this.Utils.doRealtimeSyncRequest('cancel', deleteData).then(res => {
              if (res.message == 'success') {
                   that.deleteTaskRespone(deleteData);
              }else{
                    that.$toast({
                            text: that.$t('language.exception.deleteItemFailed'),
                            type: 'fail',
                            idValue: "rightBodyList"
                        });
              }
             }, err => {
                    that.$toast({
                        text: err,
                        type: 'fail',
                        idValue: "rightBodyList"
                    });
                });
        }
        },
        //删除数据成功后的操作
        deleteTaskRespone(deleteData){
        let that = this;
        let allGroupArr=Object.assign([],that.$store.state.taskListNotGropArr);
        if(that.deleteItem.groupId){//返回未删除的数据
        that.$store.state.taskListNotGropArr = allGroupArr.filter((item) => {
            return item.groupId!=deleteData.gd;
        });
        }else{
        that.$store.state.taskListNotGropArr = allGroupArr.filter((item) => {
            return item.id!=deleteData.id;
        });
        }
        if(!that.$store.state.taskListNotGropArr.length){//如果数据删除完毕，清空选中数据
            that.$store.commit('setTaskListArrAll', []);
        }
        this.$parent.eidtTaskFlag = false;
        this.deleteTaskShow = false;
        },
        getDeleteData(){
         let deleteData;
          if (this.deleteItem.groupId) {
                 deleteData=new taskListUtils.deleteTaskData(commonUtils.getUser().id,this.deleteItem.type,null,this.deleteItem.groupId);
            } else {
                 deleteData=new taskListUtils.deleteTaskData(commonUtils.getUser().id,this.deleteItem.type,this.deleteItem.id,null);
            }
         return deleteData;
        },
        //删除企业云盘任务
        deleteBusinessTransfer(){
          var deleteData={
              id:this.deleteItem.id,
              ud:commonUtils.getUser().id
           }
           var that=this;
            this.Utils.doBusinessTransferRequest('delete', deleteData).then(res => {
               that.deleteTaskRespone(deleteData);
             }).catch(err =>{
				 if (err.reason) {
				   err = that.$t('language.exception.' + err.reason)
				 }
				    that.$toast({
				        text: err,
				        type: 'fail',
				        idValue: "rightBodyList"
				    });
			 });
        }
         
    }
}
</script>

<style>
#deleteTask {
    width: 500px;
    /*no*/
    height: 180px;
    /*no*/
}

.delete-body {
    width: 100%;
    /*no*/
    height: 140px;
    /*no*/
    color: #6f7886;
    padding-left: 20px;
    /*no*/
    box-sizing: border-box;

}

.delete-info {
    width: 100%;
    position: relative;
    top: 40px;
    /*no*/
    float: left;

}

.delete-task-button {
    float: right;
    top: 70px;
    /*no*/
    right: 20px;
    /*no*/
    position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/task_list_popups/delete_task_popups.vue